import { useNavigate } from "react-router-dom"
import useTargetStorage from "@/hooks/useTargetStorage"
import { useTranslation } from "react-i18next"
import Section from "components/layout/section"
import DeleteStorageForm from "features/storages/deleteStorageForm"
import SectionHeader from "components/layout/sectionHeader"
import SectionHeaderTitle from "components/layout/sectionHeaderTitle"
import PageTitle from "features/navigation/pageTitle"
import useStorages from "@/hooks/useStorages"
import { paramGuardStorage } from "@/utils/paramGuard"
import { FormStatus } from "@/types"
import RightSidebar from "@/components/sidebar/right/RightSidebar"

const DeleteStoragePage = () => {

    const { t } = useTranslation()
    const navigate = useNavigate()

    // Get ID from URL.
    const { targetStorageDocId: storageId } = useTargetStorage()
    const { 
        storage,
        storageStatus 
    } = useStorages({ storageId })

    // Check params and declare safe ones to use in JSX
    if (!paramGuardStorage({storageId, storage, storageStatus, navigate})) {
        return <></>
    }
    const safeStorageId = storageId!;

    // Render the JSX.
    return (
        <>
            <PageTitle title={t('titleDeleteStorage')} />
            <Section>
                <DeleteStorageForm storageId={safeStorageId} />
            </Section>
        </>
    )
}

export default DeleteStoragePage

